import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import SideMenu from '../sideMenu';
import DashboardHeader from '../topbar';
import { makeSideBarActive } from '../../utils/EllowUtils';
import * as CONSTANTS from '../../utils/CONSTANTS'
import { useNavigate } from 'react-router-dom';
import ResourceApplyPosition from "./resourecApplyPositions";
import { postCandidateToJob } from './services';
import { getPositions, getCompany, getAllocatedto, getpositionsName } from './services';
import NotificationAlert from "../../components/notification";
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';
import { getAPI } from '../../api/api';
import { REACT_APP_COMMON } from '../../utils/common';


function Position() {

  const navigate = useNavigate()
  const location = useLocation();
  const { jobId }: any = location.state || ''
  const loginId = localStorage.getItem('loginId')
  const dataItem: any = JSON.parse(localStorage.getItem("resourceApplyPositions") || "") || location.state || ''
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2)

  const [selected, setSelected] = React.useState<number>(0);
  const [jobMetadata, setJobMetadata] = useState<{
    resources: number, experienceRange: number, title: string, contractDuration: string, startDate: number, minimumBudget: number, maximumBudget: number,
    billingType: string, jobRole: { id: number, name: string }, coreSkills: [{ skillId: number, skillName: string }], otherSkills: [{ skillId: number, skillName: string }]
  }>()
  const [resources, setResources] = useState<any>()
  const [total, setTotal] = useState<number>()
  const [tableData, setTableData] = useState<any>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [coreSkills, setCoreSkills] = useState<any>([])
  const [jobExperience, setJobExperience] = useState<any>({})
  const [excludeJobId, setExcludeJobid] = useState<any>({})
  const [companyList, setCompanyList] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [positionName, setPositionName] = useState<any>()
  const [filterValues, setFilterValues] = useState<any>(null);
  const [jobRoleList, setJobRoleList] = useState<any>()

  let BreadcrumsValues = ['Resources', dataItem?.name]
  let jobIds: any;
   jobIds =  dataItem.positionStatus && dataItem.positionStatus.map((item: any) => {
      return item.job_id
    })
  useEffect(() => {
    
    if (dataItem) {
      let experience = {
        from: 0,
        to: parseFloat(dataItem.experience)
      }
      setFilterValues({ core_skills: dataItem.skills, experience: experience , allocatedTo: localStorage.getItem('Name')})
      getAllPositions("active", 1, 25,'', { skills: dataItem.skills, range: experience, allocatedTo: localStorage.getItem('Name')});
    }
    setCoreSkills(dataItem.skills)
    setJobExperience(dataItem.experience)
    setExcludeJobid(jobIds)
    getCompanyList()
    getAllocation()
    getPositionName()
    viewedpageMixpanel();

    getAPI( REACT_APP_COMMON + '/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })


  }, [])

  const getCompanyList = () => {
    getCompany().then((response: any) => {
      if (response && response.status === 1) {
        setCompanyList(response.data.map((item: any) => item.companyName));
      }
    })
  }

  const getAllocation = () => {
    getAllocatedto().then((response: any) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name
          })
        )
      }
    })
  }

  const getPositionName = () => {
    getpositionsName().then((response: any) => {
      if (response && response.status === 1) {
        setPositionName(response.data.map((item: any) => item.title ? item.title : ''));
      }
    });
  };


  const getAllCandidates = (pageSize: any, pageNumber: number) => {
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
    getAllPositions("active", page, pageSize, "", filterValues)
  }

  const searchChange = (e: any) => {
    getAllPositions("active", 1, 25, e)
  }

  const getAllPositions = (
    positionType: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filters?: any
  ) => {

    let data: any;
    if (filters) {      
      filters.positionsToExcludeForCandidateId = dataItem && dataItem.loginId
      data = {
        positionType: positionType,
        login_id: localStorage.getItem('loginId'),
        filters: filters
      }
    } else {
      data = {
        positionType: positionType,
        login_id: localStorage.getItem('loginId'),
        allocatedTo: localStorage.getItem('Name'),
        filters:{positionsToExcludeForCandidateId: dataItem && dataItem.loginId}
      }      
    }
    getPositions(searchValue, pageNumber, pageSize, data).then((resp) => {
      if (resp && resp.status === 1) {
        switch (positionType) {
          case 'active':
            // const data = resp.data.filter((item:any) => {
            //   return(item.allocatedToLoginId === loginId)
            // })
            // const length = data.length
            setTableData(resp.data)
            setTotal(resp.totalPositionsCountWithFilter)
            break;
        }
      }
    })
  }

  const closeTag = (data: any) => {
    
    if(data.core_skills === null){
      delete data.core_skills
    }
    if (
      Object.values(data).every((item) => {
        if (item === undefined) {
          return true;
        }
      }) === false
    ) {
      let value = {
        positionType: "active",
        filters: data,
      }
      applyFilter(value);
    } else {
      let value = {
        positionType: "active",
      }
      applyFilter(value);
    }
  }

  const applyFilter = (data: any) => {
    setFilterValues(data.filters);
    getAllPositions("active", 1, 25, "", data.filters);
  }

  const clickHandler = (data: any, name: string) => {

    if (name === 'positions') {
      let value: any = {
        filters: {
          positionName: data.positionName,
          allocatedTo: data.allocatedTo,
          company: data.company,
          range: data.contractDuration,
          jobRole: data.jobRole,
          positionStatus: data.positionStatus,
          typeOfJob: data.typeOfJob,
          priority: data.priority,
          dateWithin: data.dateWithin,
        },
      }
      applyFilter(value)
    }
  }


  const onSubmit = (data: any) => {

    postCandidateToJob(data).then((response: any) => {

      if (response && response.status === 1) {
      
        response && response.data.candidateDetails && response.data.candidateDetails.map((item: any, key: number) => {
        
          // mixpanelData('TG - Candidate Submitted', {
          //   'source': 'Candidate submitted to a position',
          //   'Position Name': response.data.positionName,
          //   'Recruiter Name': response.data.userName,
          //   'Resource Name': response.data.candidateDetails && response.data.candidateDetails[key].firstname + response.data.candidateDetails && response.data.candidateDetails[key].lastname,
          //   'ellow Rate': item.candidateJobMetadata.ellowRate,
          //   'Billing type': item.candidateJobMetadata.billingType,
          //   'Currency type': item.candidateJobMetadata.currencyType,
          //   'distinct_id': localStorage.getItem('Email'),
          // })

          mixpanelData('New TG - Candidate Applied', {
            'source': 'Candidate applied to a position',
            'Position name': response.data.positionName,
            'Recruiter name': response.data.userName,
            'distinct_id': localStorage.getItem('Email'),
            'Recruiter email': localStorage.getItem('Email'),
            'Candidate name': item.firstname + " " + item.lastname,
            'ellow rate': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].candidateJobMetadata && `${data.candidateMetadata[key].candidateJobMetadata.ellowRate} ${data.candidateMetadata[key].candidateJobMetadata.currencyType} / ${data.candidateMetadata[key].candidateJobMetadata.billingType}`,
            'JobId': data.jobId,
            'Candidate experience': item.workexperience + 'Years',
            'Submitted to email': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].toEmail && data.candidateMetadata[key].toEmail,
            'Additional emails submitted to': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].ccEmail && data.candidateMetadata[key].ccEmail,
            'Ellow rate enabled in the email': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].ellowRateInEmail,
            'Comments': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].candidateJobMetadata && data.candidateMetadata[key].candidateJobMetadata.comment,
            'Candidate email': item.email,
            'Company name': response.data.companyName,
            'Candidate skills': item.skills && item.skills.length > 0 && item.skills.map((skill: any) => skill.skill && skill.skill.skillName),
            'Job type': data.jobType,
            'Resource cost': data.candidateMetadata[key] && `${data.candidateMetadata[key].candidateJobMetadata.resourceRate} ${data.candidateMetadata[key].candidateJobMetadata.currencyType} / ${data.candidateMetadata[key].candidateJobMetadata.billingType}`,
            'Candidate loginid': data.candidateMetadata[key] && data.candidateMetadata[key].candidateId,
            'ellow rate in email': data.candidateMetadata[key] && data.candidateMetadata[key].candidateJobMetadata.ellowRateInEmail
          })
        })
      }
      displayNotification()
    })
  }

  const displayNotification = () => {
    setMessage('Details saved successfully')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      navigate('../resources', { state: { jobId: jobId, positionName: jobMetadata?.title } })
    }, 3000)
  }

  const onClose = () => {
    setNotification(false)
  }

  return (
    <section className="dashboardWrapper">
      {notification && <NotificationAlert onClose={onClose} closable={true} >
        {message}
      </NotificationAlert>}
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          navigateTo=""
          searchChange={''}
          seachBarKey={"seachBarKey"}
        />
        <ResourceApplyPosition
          tableData={tableData}
          onSubmit={onSubmit}
          data={tableData}
          total={total}
          pageSize={getAllCandidates}
          jobId={jobId}
          searchChange={searchChange}
          companyList={companyList}
          allocatedTo={allocatedTo}
          positionName={positionName}
          clickHandler={clickHandler}
          filterValues={filterValues}
          closeTag={closeTag}
          jobRolesList={jobRoleList}
        />
      </div>
    </section>
  )
}

export default Position